// stylis-px2rem-plugin
import {
  DECLARATION,
  Middleware,
} from 'stylis';

export type Px2RemPluginOptions = {
  remSize?: number,
  allowList?: string[],
  blockList?: string[],
}

const pxRegexp = /"[^"]+"|'[^']+'|url\([^)]+\)|(\d*\.?\d+)px/g;

const stylisPx2RemPlugin: (options?: Px2RemPluginOptions) => Middleware = ({
  remSize = 16,
  allowList,
  blockList,
} = {}) => (
  element: any,
) => {
  if (element.type === DECLARATION) {
    const declarationHasPx = element.value.match(pxRegexp);

    if (declarationHasPx) {
      // if (allowList && !allowList.includes(element.props as string)) return;
      // if (blockList && blockList.includes(element.props as string)) return;
      if (element.props.includes('border') && !element.props.includes('border-radius')) return;

      const expression = (element.children as string).replace(
        pxRegexp,
        (match, group) => (group ? Number(group) / remSize + 'rem' : match),
      );
      const reconstructedDeclaration = element.props + ':' + expression + ';';

      element.return = reconstructedDeclaration;
    }
  }
};

Object.defineProperty(stylisPx2RemPlugin, 'name', { value: 'stylisPx2RemPlugin' });

export default stylisPx2RemPlugin;
